// pages/Unauthorized.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Страница "Нет доступа"
 * @returns {JSX.Element} - Компонент для рендеринга
 */
const UnauthorizedPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  
  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] py-12 px-4 sm:px-6 lg:px-8">
      <div className="text-center">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-24 w-24 text-red-500 mx-auto mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
        
        <h1 className="text-4xl font-bold text-gray-900 mb-4">Доступ запрещен</h1>
        
        <p className="text-lg text-gray-600 mb-8">
          У вас нет прав для доступа к запрашиваемой странице.
        </p>
        
        <div className="text-md text-gray-500 mb-8">
          {user ? (
            <>
              <p>Вы вошли как: <span className="font-semibold">{user.fullName}</span></p>
              <p>Роль: <span className="font-semibold">{user.role}</span></p>
            </>
          ) : (
            <p>Вы не авторизованы в системе.</p>
          )}
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => navigate('/')}
            className="px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Вернуться на главную
          </button>
          
          {!user && (
            <button
              onClick={() => navigate('/login')}
              className="px-6 py-3 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
            >
              Войти в систему
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;